import React, { useEffect, useRef, useState } from "react";
import Modal from "../modal/Modal";
import {
  MODAL_TYPE,
  WAYS_TO_STYLE_OPEN_MODAL_EVENT,
  MODAL_CONTENT_LOAD_DELAY_MS,
} from "../../constants";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import useEventBus from "../../hooks/useEventBus";
import { StylingLookWithStockPrice } from "../../types/productTypes/stylingLookProduct";
import WaysToStyleModalCarousel from "./WaysToStyleModalCarousel";
import styles from "./WaysToStyleModal.scss";
import classnamesBind from "classnames/bind";

const classnames = classnamesBind.bind(styles);
import { useWaysToStyle } from "../../context/waysToStyle/WaysToStyleContext";

interface WaysToStyleModalData {
  selectedLook: StylingLookWithStockPrice;
  lookIndex: number;
  thumbnailIndex: number;
}

const WaysToStyleModal: React.FC = () => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };
  const { resetStockPriceData } = useWaysToStyle();
  const [open, setOpen] = useState(false);
  const [contentLoaded, setContentLoaded] = useState(false);
  const [focusOnCloseElement, setFocusOnCloseElement] =
    useState<HTMLElement | null>(null);
  const [stylingLooksModalData, setStylingLooksModalData] =
    useState<WaysToStyleModalData | null>(null);
  const [modalId] = useState<string>(
    `${MODAL_TYPE.SIDE}${Math.floor(Math.random() * 10000)}`
  );
  const [selectedIndex, setSelectedIndex] = useState(0);
  const contentLoadTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearContentLoadTimer = () => {
    if (contentLoadTimer.current) {
      clearTimeout(contentLoadTimer.current);
      contentLoadTimer.current = null;
    }
  };

  useEffect(() => clearContentLoadTimer, []);

  useEventBus(
    WAYS_TO_STYLE_OPEN_MODAL_EVENT,
    ({
      focusOnCloseElement,
      data,
    }: {
      focusOnCloseElement: HTMLElement;
      data?: WaysToStyleModalData | null;
    }) => {
      setOpen(true);
      setFocusOnCloseElement(focusOnCloseElement);

      if (!data) {
        clearContentLoadTimer();
        setContentLoaded(false);
        setStylingLooksModalData(null);
        return;
      }
      setStylingLooksModalData(data);
      setSelectedIndex(data.lookIndex);
      clearContentLoadTimer();
      contentLoadTimer.current = setTimeout(() => {
        setContentLoaded(true);
      }, MODAL_CONTENT_LOAD_DELAY_MS);
    },
    []
  );

  const renderContent = () => {
    if (!stylingLooksModalData) return null;

    const { selectedLook, lookIndex, thumbnailIndex } = stylingLooksModalData;

    return (
      <div className={classnames({ isLoading: !contentLoaded })}>
        <WaysToStyleModalCarousel selectedIndex={selectedIndex} isOpen={open} />
        <p>Clicked Look Index: {lookIndex}</p>
        <p>Clicked Thumbnail Index: {thumbnailIndex}</p>
        {selectedLook.products.map((product, i) => (
          <div key={i}>
            <p>ProductName: {product.name}</p>
            <p>IsInStock: {product.isInStock ? "Yes" : "No"}</p>
            <p>Price: {product.productPrice?.current?.text || "N/A"}</p>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Modal
      title={getTranslation("pdp_associated_buy_the_look_title")}
      open={open}
      focusOnClose={focusOnCloseElement}
      modalId={modalId}
      modalType={MODAL_TYPE.SIDE}
      closeModal={() => {
        clearContentLoadTimer();
        setOpen(false);
        setContentLoaded(false);
        resetStockPriceData();
      }}
      contentLoaded={contentLoaded}
    >
      {renderContent()}
    </Modal>
  );
};

export default WaysToStyleModal;
